/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TestAutotaskConnection200ResponseFields } from './TestAutotaskConnection200ResponseFields';
import {
    TestAutotaskConnection200ResponseFieldsFromJSON,
    TestAutotaskConnection200ResponseFieldsFromJSONTyped,
    TestAutotaskConnection200ResponseFieldsToJSON,
    TestAutotaskConnection200ResponseFieldsToJSONTyped,
} from './TestAutotaskConnection200ResponseFields';

/**
 * 
 * @export
 * @interface TestAutotaskConnection200Response
 */
export interface TestAutotaskConnection200Response {
    /**
     * 
     */
    success: boolean;
    /**
     * 
     */
    message: string;
    /**
     * 
     */
    companyName?: string;
    /**
     * 
     */
    statusCount?: number;
    /**
     * 
     */
    fields?: TestAutotaskConnection200ResponseFields;
}

/**
 * Check if a given object implements the TestAutotaskConnection200Response interface.
 */
export function instanceOfTestAutotaskConnection200Response(value: object): value is TestAutotaskConnection200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TestAutotaskConnection200ResponseFromJSON(json: any): TestAutotaskConnection200Response {
    return TestAutotaskConnection200ResponseFromJSONTyped(json, false);
}

export function TestAutotaskConnection200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestAutotaskConnection200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'statusCount': json['statusCount'] == null ? undefined : json['statusCount'],
        'fields': json['fields'] == null ? undefined : TestAutotaskConnection200ResponseFieldsFromJSON(json['fields']),
    };
}

export function TestAutotaskConnection200ResponseToJSON(json: any): TestAutotaskConnection200Response {
    return TestAutotaskConnection200ResponseToJSONTyped(json, false);
}

export function TestAutotaskConnection200ResponseToJSONTyped(value?: TestAutotaskConnection200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'companyName': value['companyName'],
        'statusCount': value['statusCount'],
        'fields': TestAutotaskConnection200ResponseFieldsToJSON(value['fields']),
    };
}

